export const ApiEndpointMethodColorMapping = {
  get: 'blue',
  put: 'orange',
  patch: 'pink',
  del: 'red',
  post: 'green'
};
